import React, { Dispatch, SetStateAction } from 'react';
import { DonorPhysicalInfo } from '../../models/DonorPhysicalInfo';

type PhysicalInfoProps = {
  physicalInfo: DonorPhysicalInfo | null;
  setPhysicalInfo: Dispatch<SetStateAction<DonorPhysicalInfo | null>>;
}

const PhysicalInfo = (props: PhysicalInfoProps) => {
  return (
    <>
      <h3 className="sub_title">身体情報</h3>
      <div className="form">
        <dl className="graf_list">
          <dt>血液型</dt>
          <dd className="flex">
            <div className="select select01">
              <select
                value={ props.physicalInfo?.bloodType || '' }
                onChange={ e => props.setPhysicalInfo(prev => prev ? prev.set("bloodType", e.target.value) : null) }
              >
                <option value="">選択してください</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="AB">AB</option>
                <option value="O">O</option>
              </select>
            </div>
            <span>Rh</span>
            <div className="select select01">
              <select
                value={ props.physicalInfo?.bloodRh || '' }
                onChange={ e => props.setPhysicalInfo(prev => prev ? prev.set("bloodRh", e.target.value) : null) }
              >
                <option value="">選択してください</option>
                <option value="UNKNOWN">不明</option>
                <option value="PLUS">+</option>
                <option value="MINUS">-</option>
              </select>
            </div>
          </dd>
          <dt>身長</dt>
          <dd className="flex short">
            <input
              type="number"
              step="0.1"
              value={ props.physicalInfo?.height || '' }
              onWheel={ e => e.currentTarget.blur() }
              onChange={ e => {
                const value = e.target.value;
                const regex = /^[0-9]*$/;
                if (regex.test(value)) {
                  props.setPhysicalInfo(prev => prev ? prev.set("height", Number(value)) : null);
                }
              }}
            />
            <span>cm</span>
          </dd>
          <dt>体重</dt>
          <dd className="flex short">
            <input
              type="number"
              step="0.1"
              value={ props.physicalInfo?.weight || '' }
              onWheel={ e => e.currentTarget.blur() }
              onChange={ e => {
                const value = e.target.value;
                const regex = /^[0-9]*(\.[0-9]{0,1})?$/;
                if (regex.test(value)) {
                  props.setPhysicalInfo(prev => prev ? prev.set("weight", Number(value)) : null);
                }
              }}
            />
            <span>kg</span>
          </dd>
          <dt>体格</dt>
          <dd>
            <div className="select select01">
              <select
                value={ props.physicalInfo?.bodyFigure || '' }
                onChange={ e => props.setPhysicalInfo(prev => prev ? prev.set("bodyFigure", e.target.value) : null) }
              >
                <option value="">選択してください</option>
                <option value="SKINNY">痩せている</option>
                <option value="THIN">細め</option>
                <option value="NORMAL">普通</option>
                <option value="THICK">がっちり</option>
                <option value="FAT">太め</option>
              </select>
            </div>
          </dd>
          <dt>まぶた</dt>
          <dd>
            <div className="select select01">
              <select
                value={ props.physicalInfo?.eyelid || '' }
                onChange={ e => props.setPhysicalInfo(prev => prev ? prev.set("eyelid", e.target.value) : null) }
              >
                <option value="">選択してください</option>
                <option value="SINGLE">一重</option>
                <option value="HOODED">奥二重</option>
                <option value="DOUBLE">二重</option>
              </select>
            </div>
          </dd>
          <dt>髪質</dt>
          <dd>
            <div className="select select01">
              <select
                value={ props.physicalInfo?.hairType || '' }
                onChange={ e => props.setPhysicalInfo(prev => prev ? prev.set("hairType", e.target.value) : null) }
              >
                <option value="">選択してください</option>
                <option value="STRAIGHT">直毛</option>
                <option value="WAVY">クセ毛</option>
                <option value="SOFT">軟毛</option>
                <option value="HARD">硬毛</option>
                <option value="COARSE">剛毛</option>
              </select>
            </div>
          </dd>
          <dt>髪色</dt>
          <dd>
            <div className="select select01">
              <select
                value={ props.physicalInfo?.hairColor || '' }
                onChange={ e => props.setPhysicalInfo(prev => prev ? prev.set("hairColor", e.target.value) : null) }
              >
                <option value="">選択してください</option>
                <option value="BLACK">黒色</option>
                <option value="DARK_BROWN">濃い茶色</option>
                <option value="LIGHT_BROWN">薄い茶色</option>
                <option value="OTHER">その他</option>
              </select>
            </div>
          </dd>
        </dl>
      </div>
    </>
  )
}

export default PhysicalInfo;
